import ScheduledMedicine from '@/domains/agenda/health/scheduled-medicine/scheduled-medicine';
import StudentNap from '@/domains/agenda/health/nap/main';
import StudentEvacueted from '@/domains/agenda/health/evacueted/main';
import StudentUrineQuantity from '@/domains/agenda/health/urine-quantity/urine-quantity';
import StudentToothBrushing from '@/domains/agenda/health/tooth-brushing/main';
import StudentBathQuantity from '@/domains/agenda/health/bath-quantity/StudentBathQuantity.vue';
import StudentDiapersQuantity from '@/domains/agenda/health/diapers-quantity/StudentDiapersQuantity.vue';
import StudentEventualMedicine from '@/domains/agenda/health/eventual-medicine/main';

export default {
	name: 'health',
	components: {
		ScheduledMedicine,
		StudentNap,
		StudentEvacueted,
		StudentUrineQuantity,
		StudentToothBrushing,
		StudentBathQuantity,
		StudentDiapersQuantity,
		StudentEventualMedicine
	}
};



// WEBPACK FOOTER //
// ./sources/domains/agenda/health/index.js